"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BattleSprite = void 0;
const blocks_1 = require("../blocks");
const pixi_js_1 = require("pixi.js");
const AssetManager_1 = __importDefault(require("../managers/AssetManager"));
const Global_1 = require("../Global");
const gsap_core_1 = require("gsap/gsap-core");
const brushcenter_svg_1 = __importDefault(require("../../assets/svg/brushcenter.svg"));
const brushleft_svg_1 = __importDefault(require("../../assets/svg/brushleft.svg"));
const brushright_svg_1 = __importDefault(require("../../assets/svg/brushright.svg"));
const medal_sparkles_svg_1 = __importDefault(require("../../assets/svg/medal_sparkles.svg"));
const settings_1 = require("../config/settings");
class BattleSprite extends blocks_1.Block {
    constructor(app, sparkles = false) {
        super(app);
        this.popSprite = AssetManager_1.default.popSprite();
        this.popSprite.tint = settings_1.Settings.blackColor;
        this.popSprite.loop = false;
        this.popSprite.visible = false;
        this.popSprite.onComplete = () => {
            this.popSprite.gotoAndStop(0);
            this.popSprite.visible = false;
        };
        const shock = () => {
            this.popSprite.visible = true;
            this.popSprite.play();
            if (this.finish) {
                this.finish();
            }
        };
        // Sparkles
        if (sparkles) {
            this.sparklesSprite = pixi_js_1.Sprite.from(medal_sparkles_svg_1.default);
            this.sparklesSprite.name = 'sparkles';
            this.sparklesSprite.anchor.set(0.5);
            this.addChild(this.sparklesSprite);
        }
        // Animate brushes
        this.tm = gsap_core_1.gsap.timeline({ paused: true, onStart: () => {
                if (this.sparklesSprite) {
                    this.sparklesSprite.visible = false;
                }
            }, onComplete: () => {
                if (this.sparklesSprite) {
                    this.sparklesSprite.visible = true;
                }
            } });
        this.brushSprite = pixi_js_1.Sprite.from(brushcenter_svg_1.default);
        this.brushSprite.anchor.set(0.5, 0.2);
        this.addChild(this.brushSprite);
        this.tm.to(this.brushSprite, {
            pixi: {
                skewX: -12,
                x: (0, Global_1.px)(13)
            },
            ease: 'power1.inOut',
            duration: 0.5
        }, 'charge').to(this.brushSprite, {
            pixi: {
                skewX: 0,
                x: (0, Global_1.px)(-1)
            },
            duration: 0.1
        }, 'strike').call(shock, [], 'shock');
        this.addChild(this.popSprite);
        this.brushes = [pixi_js_1.Sprite.from(brushleft_svg_1.default), pixi_js_1.Sprite.from(brushright_svg_1.default)];
        for (let i = 0; i < this.brushes.length; i++) {
            const brushSprite = this.brushes[i];
            const side = (i ? 1 : -1);
            const ocenter = side * (0, Global_1.px)(-2);
            brushSprite.name = i.toString();
            brushSprite.anchor.set(0.5, 0.7);
            this.addChild(brushSprite);
            this.tm.to(brushSprite, {
                pixi: {
                    rotation: side * 60,
                    x: (0, Global_1.px)(side * 32) + ocenter
                },
                ease: 'power1.inOut',
                duration: 0.5
            }, 'charge').to(brushSprite, {
                pixi: {
                    rotation: 0,
                    x: ocenter
                },
                duration: 0.1
            }, 'strike');
        }
        this.tms.add(this.tm);
        this.layout();
    }
    play() {
        var _a;
        if (this.tm && !this.tm.isActive()) {
            this.tm.restart();
        }
        else {
            (_a = this.tm) === null || _a === void 0 ? void 0 : _a.play();
        }
    }
    stop() {
        if (this.tm && this.tm.isActive() && ['shock', 'strike'].indexOf(this.tm.currentLabel()) === -1) {
            this.tm.reverse();
        }
    }
    pause() {
        this.stop();
    }
    layout() {
        super.layout();
        this.popSprite.scale.set((0, Global_1.px)(this.overSmallSize ? 0.4 : 0.3));
        this.popSprite.position.set(0, (0, Global_1.px)(this.overSmallSize ? 56 : 50));
        this.brushSprite.scale.set((0, Global_1.px)(this.overSmallSize ? 0.14 : 0.12));
        this.brushSprite.position.set((0, Global_1.px)(-1), (0, Global_1.px)(this.overSmallSize ? 26 : 24));
        if (this.sparklesSprite) {
            this.sparklesSprite.position.set((0, Global_1.px)(-2), (0, Global_1.px)(55));
            this.sparklesSprite.scale.set((0, Global_1.px)(-.32));
        }
        this.brushes.forEach((brushSprite, i) => {
            const side = (i ? 1 : -1);
            const ocenter = side * (0, Global_1.px)(-2);
            brushSprite.scale.set((0, Global_1.px)(this.overSmallSize ? 0.1267 : 0.1067));
            brushSprite.position.set(ocenter, (0, Global_1.px)(this.overSmallSize ? 70 : 63));
        });
    }
}
exports.BattleSprite = BattleSprite;
